/* eslint-disable @typescript-eslint/no-redeclare */
import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  CLEAR_API_CALL_MESSAGE,
  RESET_API_LOADER,
} from "../Action/actionTypes";

interface InitialState {
  loading: boolean;
  message: string;
  error: boolean;
}

const initialState: InitialState = {
  loading: false,
  message: "",
  error: false,
};

const ToastMessageReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case API_CALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case API_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
        error: false,
      };
    case API_CALL_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.payload,
        error: true,
      };
    case CLEAR_API_CALL_MESSAGE:
      return {
        ...initialState,
      };
    case RESET_API_LOADER:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default ToastMessageReducer;
